import React from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { takeDetailsValidation } from "../../helpers/formValidations";
import { useForm } from "../../hooks";
import { DateUtility, nameFormatting } from "../../helpers/commonFunction";
import { useSelector } from "react-redux";
import { CameraFillIcon } from "../../icon/icon";
import CustomImageSwiper from "../CustomImageSwiper";

const PhotoDetailsModal = (props) => {
  const { isLoading, selfiesList, openSelfieModal, onSubmit, ...rest } = props;
  const { user } = useSelector((state) => state.userReducer);

  const getActivity = () => {
    return user?.user_role === "USER"
      ? "Daily GT Basket Cleaning"
      : user?.user_role === "FTS"
      ? "Bi-Weekly Treatment Dosing"
      : user?.user_role === "AUDITOR"
      ? "Monthly FOG Audit"
      : user?.user_role === "LAB"
      ? "Quarterly Lab Test"
      : null;
  };

  const initialFValues = {
    restaurant: "",
    branch: "",
    personnel: nameFormatting(user, "LF"),
    activity: getActivity(),
    recode_time: new Date(),
    address: "",
  };

  const validate = (fieldValues = values) => {
    let temp = { ...errors };
    return takeDetailsValidation(
      fieldValues,
      temp,
      values,
      setValues,
      setErrors
    );
  };
  const { errors, setErrors, values, setValues, handleInputChange } = useForm(
    initialFValues,
    true,
    validate
  );

  const handleSubmit = () => {
    if (validate()) {
      onSubmit(values);
      setValues(initialFValues);
      setErrors(initialFValues);
    }
  };

  return (
    <Modal
      {...rest}
      centered
      size="lg"
      contentClassName="photo-details-modal"
      className="fog_take_details_modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          Details{" "}
          <span role="button" onClick={() => openSelfieModal(true)}>
            {CameraFillIcon}
          </span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="photo-details-img-wrapper">
          <CustomImageSwiper dataList={selfiesList} />
        </div>
        <Form className="photo-details-form">
          <Form.Group className="mb-2">
            <Form.Label>
              Restaurant<span>:</span>
            </Form.Label>
            <div className="input-wrapper">
              <Form.Control
                name="restaurant"
                value={values.restaurant}
                onChange={handleInputChange}
                placeholder="Enter restaurant name"
              />
              {errors.restaurant && (
                <span className="tc_error_text">
                  {errors && errors.restaurant}
                </span>
              )}
            </div>
          </Form.Group>
          <Form.Group className="mb-2">
            <Form.Label>
              Branch<span>:</span>
            </Form.Label>
            <div className="input-wrapper">
              <Form.Control
                name="branch"
                value={values.branch}
                onChange={handleInputChange}
                placeholder="Enter branch name"
              />
              {errors.branch && (
                <span className="tc_error_text">{errors && errors.branch}</span>
              )}
            </div>
          </Form.Group>
          <Form.Group className="mb-2">
            <Form.Label>
              Personnel<span>:</span>
            </Form.Label>
            <Form.Control
              name="personnel"
              value={values.personnel}
              onChange={handleInputChange}
              placeholder="Enter personnel name"
              disabled={user?.lastname}
            />
          </Form.Group>
          <Form.Group className="mb-2">
            <Form.Label>
              Activity<span>:</span>
            </Form.Label>
            <Form.Control
              name="activity"
              value={values.activity}
              onChange={handleInputChange}
              placeholder="Enter activity"
              disabled={user?.user_role}
            />
          </Form.Group>
          <Form.Group className="mb-2">
            <Form.Label>
              Date/Time<span>:</span>
            </Form.Label>
            <Form.Control
              name="recode_time"
              value={DateUtility.mmddyywithDay(values.recode_time)}
              placeholder="MM/DD/YY HH:MM AM/PM"
              disabled
            />
          </Form.Group>
          <div className="d-grid mt-5">
            <Button type="button" onClick={handleSubmit} disabled={isLoading}>
              Submit
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default PhotoDetailsModal;
